"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WellbeingScores = void 0;
var WellbeingScores = /** @class */ (function () {
    function WellbeingScores() {
    }
    WellbeingScores.defaultProps = function () {
        return {
            physical: {
                nutrition: {
                    food: 0,
                    fitness: 0,
                    rest: 0
                },
                health: {
                    genetics: 0,
                    surgical: 0,
                    reproductive: 0,
                    cancer: 0,
                    cardiovascular: 0
                }
            },
            emotional: {
                bonding: {
                    human: 0
                },
                behavior: {
                    obedience: 0,
                    agression: 0,
                    anxiety: 0
                }
            },
            social: {
                play: {
                    self: 0,
                    conspecifics: 0,
                    human: 0,
                    otherAnimals: 0,
                    objects: 0
                },
                interaction: {
                    self: 0,
                    conspecifics: 0,
                    human: 0,
                    otherAnimals: 0,
                    objects: 0
                }
            },
            cognitive: {
                engagement: {},
                problemSolving: {}
            }
        };
    };
    ;
    WellbeingScores.l3 = function (scores, key) {
        for (var l1 in scores) {
            if (!scores.hasOwnProperty(l1)) {
                continue;
            }
            for (var l2 in scores[l1]) {
                if (!scores[l1].hasOwnProperty(l1)) {
                    continue;
                }
                for (var l3 in scores[l2]) {
                    if (!scores[l1][l2].hasOwnProperty(l1)) {
                        continue;
                    }
                    if (l3 === key) {
                        return scores[l1][l2][l3];
                    }
                }
            }
        }
        return null;
    };
    WellbeingScores.path = function (scores, key) {
        for (var l1 in scores) {
            if (!scores.hasOwnProperty(l1)) {
                continue;
            }
            if (l1 === key) {
                return [l1];
            }
            for (var l2 in scores[l1]) {
                if (!scores[l1].hasOwnProperty(l1)) {
                    continue;
                }
                if (l2 === key) {
                    return [l1, l2];
                }
                for (var l3 in scores[l2]) {
                    if (!scores[l1][l2].hasOwnProperty(l1)) {
                        continue;
                    }
                    if (l3 === key) {
                        return [l1, l2, l3];
                    }
                }
            }
        }
        return [];
    };
    return WellbeingScores;
}());
exports.WellbeingScores = WellbeingScores;
